import {
  FETCH_LOAD_ALL_MASTER_TEMPLATE_REQUEST,
  FETCH_LOAD_ALL_MASTER_TEMPLATE_SUCCESS,
  FETCH_LOAD_ALL_MASTER_TEMPLATE_FALUIRE,
} from './loadAllMasterTemplateTypes'

const initialState = {
  loading: false,
  allMasterTemplateList: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_LOAD_ALL_MASTER_TEMPLATE_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_LOAD_ALL_MASTER_TEMPLATE_SUCCESS : return {
      ...state,
      allMasterTemplateList: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_LOAD_ALL_MASTER_TEMPLATE_FALUIRE : return {
      ...state,
      loading: false,
      allMasterTemplateList: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
